import * as http from '../utils/request'
import axios from 'axios'
import {
  generateRegisterCode,
  getParents,
  getUserName,
  getRoleIdRenon,
  getLoginData
} from "@/utils/auth";

export function subusers({
  useranme = "",
  nickname = "",
  level,
  current_page,
  page_size,
  only_sub_user = false,
  isShowParent = true,
  allInstall = false
}) {
  let filter = {}
  if (isShowParent) {
    if (getRoleIdRenon() == 0) {
      filter["parent"] = {
        "$regex": getUserName(),
        "$options": "i"
      };
    } else {
      filter = {
        "parent": getUserName()
      };
    }

  } else {
    filter = {
      "parent": getUserName()
    };
  }

  if (level !== undefined) {
    filter["$and"] = [
      {
        "parents" :{
          "$size": level
        }
      },
      {
        "parents": {
          "$regex": getUserName(),
          "$options": "i"
        }
      }
    ]
  }
  if (allInstall) {
    delete filter['parent'];
  }
  let json = filter;
  if (useranme) {
    json["username"] = JSON.parse('{"$regex":"' + useranme + '","$options":"i"}')
  }
  if (nickname) {
    json["nickname"] = JSON.parse('{"$regex":"' + nickname + '","$options":"i"}')
  }
  // json["parents"]=getUserName();
  // return http.get("/v1/subusers", {
  //   filter: JSON.stringify(json),
  //   skip,
  //   limit,
  //   descend: true
  // });

  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let parentId = userInfo.parent_id;

  let parentInfo = !only_sub_user ? {parent_id: parentId} : {};

  return http.get(`/v1/admin/tenant/tenants/${tenantId}/users`, {
    // parent_id: parentId,
    current_page: current_page || 1,
    page_size: page_size || 100,
    name: useranme,
    only_sub_user: only_sub_user,
    ...parentInfo
  })
}

export function subusersPlant({
  useranme = "",
  nickname = "",
  level,
  current_page,
  page_size,
  isShowParent = true,
  only_sub_user,
  leve4
}) {

  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let parentId = userInfo.parent_id;

  let parentInfo = !only_sub_user ? {parent_id: parentId} : {};

  //  json["desc"] = {"$regex": getUserName(), "$options": "i"};
  return http.get(`/v1/admin/tenant/tenants/${tenantId}/users`, {
    current_page: current_page || 1,
    page_size: page_size || 100,
    search: useranme,
    parent_id: parentId,
    only_sub_user: only_sub_user,
    // ...parentInfo
  })
  
  let filter = {}
  if (isShowParent) {
    if (getRoleIdRenon() == 0) {
      filter["parent"] = {
        "$regex": getUserName(),
        "$options": "i"
      };
    } else {
      filter = {
        "parent": getUserName()
      };
    }

  } else {
    filter = {
      "parent": leve4
    };
  }

  if (level !== undefined) {
    filter["parents"] = {
      "$size": level
    };

  }
  let json = filter;
  if (useranme) {
    json["username"] = JSON.parse('{"$regex":"' + useranme + '","$options":"i"}')
  }
  if (nickname) {
    json["nickname"] = JSON.parse('{"$regex":"' + nickname + '","$options":"i"}')
  }
  // json["parents"]=getUserName();
  return http.get("/v1/subusers", {
    filter: JSON.stringify(json),
    skip,
    limit,
    descend: true
  });
}

export async function detailSubUser(useranme) {
  let filter = '{"username":"' + useranme + '"}'

  const res = await http.get("/v1/admin/tenant/users/self");

  if (res) {
    return res
  }
  return null;
}


export function count({
  level,
  useranme,
  only_sub_user = true
}) {
  let filter = {}

  if (getRoleIdRenon() == 0) {

    filter['parent'] = {
      "$regex": getUserName(),
      "$options": "i"
    }
  } else {

    filter = {
      "parent": getUserName()
    };
  }


  if (useranme) {
    filter["username"] = JSON.parse('{"$regex":"' + useranme + '","$options":"i"}')
  }

  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let parentId = userInfo.parent_id;

  //  json["desc"] = {"$regex": getUserName(), "$options": "i"};
  return http.get(`/v1/admin/tenant/tenants/${tenantId}/users`, {
    // parent_id: parentId,
    page_size: 100,
    name: useranme,
    only_sub_user: only_sub_user,
  })
}


export function createSubUser(params = {}) {
  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let level = userInfo.level

  // debugger
  // let parents = getParents();
  // parents.push(params.username);
  // params.parents = parents;
  // params.parent = getUserName();
  // params.user_extra = JSON.stringify(params.extra);
  // params.accessControllerList = ["62f3ace26258cfb9289ec140"];
  //  delete params.extra;
  // '/v1/admin/tenant/user-tenants/sub-user'
  return http.postJSON(`/v1/admin/tenant/tenants/${tenantId}/users`, {
    email: params.subemail,
    password: params.password,
    name: params.username,
    address: params.subaddress,

    role_ids: level == 6 ? '22521' : '22518' // level 为6 则赋角色 22521（终端用户），其他权限都为 22518（三级经销商）
    // extension_code: userInfo.parent_name
  })
}




// https://www.zlgcloud.com/v1/subusers/test007

// export function detailSubUser(userName) {
//   return http.get('/v1/subusers/'+userName, {})
// }
export function editSubUser(params = {}) {
  let user_extra = {};
  if (params.user_extra) {
    user_extra = JSON.parse(params.user_extra);
  }
  user_extra.region = params.region ? params.region : "";
  user_extra.country = params.country ? params.country : "";
  user_extra.remark = params.remark ? params.remark : "";
  user_extra.mobile = params.submobile ? params.submobile : "";
  params.user_extra = JSON.stringify(user_extra)

  let sendParams = {
    desc: "",
    nickname: "",
    ...params
  }
  delete sendParams.username;
  delete sendParams.submobile;
  // return http.putJSON('/v1/subusers/' + params.username, sendParams)

  return http.putJSON('/admin/tenant/users/self', {
    address: params.subaddress,
    city: params.region,
    country: params.country,
    company: params.subcompany,
    email: params.subemail,
    name: params.username,
    description: params.remark
  })
}

export function editSubUserPlant(username, params) {
  return http.putJSON('/admin/tenant/users/self', params, true);
}
export function editPlant(userName, nickName, email, address, mobile, parent, parents) {
  let params = {};
  // params["username"]=Common.generateRandomString(12);
  // params["password"]=Common.generateRandomString(12);
  params["subaddress"] = address;
  params["nickname"] = nickName;
  params["subemail"] = email;
  params["submobile"] = mobile;
  params["parent"] = parent;
  params["parents"] = parents;
  // params["username"]=userName;
  return editSubUserPlant(userName, params);
}


export function updateDevDesc(params = {}, urlParams = {}) {
  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let thingsId = urlParams.thingsId;

  return http.putJSON(`/v1/things/tenants/${tenantId}/things/${thingsId}`, params)

  return http.putJSON('/v1/devices/' + devId + "?devtype=" + devType, {
    desc
  })
}

export function bindUpdate(devId, devType, params) {
  return http.putJSON('/v1/devices/' + devId + "?devtype=" + devType, params)
}

export function deviceEdit(params = {}) {
  let user_extra = {};
  // if (params) {
  //   user_extra = JSON.parse(params);
  // }
  // user_extra.user = params.user?params.user:"";
  user_extra.name = params.name ? params.name : "";
  user_extra.mobile = params.mobile ? params.mobile : "";
  user_extra.email = params.email ? params.email : "";
  user_extra.company = params.company ? params.company : "";
  user_extra.address = params.address ? params.address : "";
  user_extra.installTime = params.installTime ? params.installTime : "";
  user_extra.parent = params.parent;
  user_extra.level = params.level;
  params.user_extra = JSON.stringify(user_extra)
  delete params.user;
  let sendParams = {
    desc: params.user_extra,
    devname: user_extra.name

  }

  return http.putJSON('/v1/devices/' + params.devid + "?devtype=" + params.devtype, sendParams)
}


export function deleteUser(list = []) {
  if (list.length == 0) {
    return;
  }
  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;

  return http.deleteRequest(`/v1/admin/tenant/tenants/${tenantId}/users/${list[0]}`)
}

// 下载用户列表的 CSV 文件接口
// 参数 user_id 不传则为当前登录用户下的所有子用户，传指定 user_id 则导出指定用户下的所有子用户
export const downloadUsersCsvFile = (userId) => {
  const url = userId ? `/v1/admin/tenant/users-csv-file?user_id=${userId}` : `/v1/admin/tenant/users-csv-file`;
  return axios.get(url, {
    responseType: 'blob',
    headers: {
      'accept': 'application/csv'
    }
  });
};

// /v1/subusers/test011
